import React, { useState } from "react";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import {
  Button,
  Card,
  CardHeader,
  Checkbox,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@material-ui/core";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: "auto"
    },
    cardHeader: {
      padding: theme.spacing(1)
    },
    list: {
      height: 220,
      backgroundColor: theme.palette.background.paper,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0)
    }
  })
);

function not(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) === -1);
}

function intersection(a: any, b: any) {
  return a.filter((value: any) => b.indexOf(value) !== -1);
}

function union(a: any, b: any) {
  return [...a, ...not(b, a)];
}

export default function TransferList({ onSelect, selected, users }: any) {
  const classes = useStyles();

  const [checked, setChecked] = useState<any>([]);
  const left = not(users.options, selected);
  const right = selected;

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value: any) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items: any) => intersection(checked, items).length;

  const handleToggleAll = (items: any) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleMoveRight = () => {
    onSelect(right.concat(leftChecked));
  };

  const handleMoveLeft = () => {
    onSelect(not(right, rightChecked));
  };

  const Items = ({ title, items }: any) => {
    return (
      <Card>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <Checkbox
              onClick={handleToggleAll(items)}
              checked={
                numberOfChecked(items) === items.length && items.length !== 0
              }
              indeterminate={
                numberOfChecked(items) !== items.length &&
                numberOfChecked(items) !== 0
              }
              disabled={items.length === 0}
              inputProps={{ "aria-label": "all items selected" }}
            />
          }
          title={title}
          subheader={`${numberOfChecked(items)}/${items.length} selected`}
        />
        <Divider />
        <List className={classes.list} dense>
          {items.map((item: any) => (
            <ListItem key={item.id} button onClick={handleToggle(item)}>
              <ListItemIcon>
                <Checkbox
                  checked={checked.find((i: any) => i === item) ? true : false}
                />
              </ListItemIcon>
              <ListItemText primary={item.full_name} />
            </ListItem>
          ))}
          <ListItem />
        </List>
      </Card>
    );
  };

  return (
    <Grid container spacing={1} alignItems="center" className={classes.root}>
      <Grid item xs={5}>
        <Items title="Available Users" items={left} />
      </Grid>
      <Grid item xs={2}>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleMoveRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            <ChevronRightIcon />
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleMoveLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            <ChevronLeftIcon />
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={5}>
        <Items title="Selected Users" items={right} />
      </Grid>
    </Grid>
  );
}
